import { apiGet, apiPost, apiDelete } from './client';
import type { AiAgentConsultingPeer, OperationResult, PagedItemsResult } from './types';

export async function getPeersForAgent(agentId: number, pageSize = 100): Promise<AiAgentConsultingPeer[]> {
  const result = await apiGet<OperationResult<PagedItemsResult<AiAgentConsultingPeer>>>(
    '/api/AiAgentConsultingPeer/Search',
    { primaryAgentId: agentId, pageNo: 1, pageSize }
  );
  if (!result.isSuccess || !result.data) {
    throw new Error(result.message || 'Failed to load peer agents');
  }
  return result.data.data ?? [];
}

export interface PeerInput {
  id?: number;
  primaryAgentId: number;
  peerAgentId: number;
  scope?: string;
  exclusionGuidance?: string;
  isActive?: boolean;
}

export async function addPeer(input: PeerInput): Promise<void> {
  const result = await apiPost<OperationResult>('/api/AiAgentConsultingPeer/Add', {
    primaryAgentId: input.primaryAgentId,
    peerAgentId: input.peerAgentId,
    scope: input.scope ?? '',
    exclusionGuidance: input.exclusionGuidance ?? '',
    isActive: input.isActive ?? true,
  });
  if (!result.isSuccess) throw new Error(result.message || 'Failed to add peer');
}

export async function updatePeer(input: PeerInput): Promise<void> {
  if (input.id == null) throw new Error('Peer id is required for update');
  const result = await apiPost<OperationResult>('/api/AiAgentConsultingPeer/Update', {
    id: input.id,
    primaryAgentId: input.primaryAgentId,
    peerAgentId: input.peerAgentId,
    scope: input.scope ?? '',
    exclusionGuidance: input.exclusionGuidance ?? '',
    isActive: input.isActive ?? true,
  });
  if (!result.isSuccess) throw new Error(result.message || 'Failed to update peer');
}

export async function removePeer(id: number): Promise<void> {
  const result = await apiDelete<OperationResult>(`/api/AiAgentConsultingPeer/Remove/${id}`);
  if (!result.isSuccess) throw new Error(result.message || 'Failed to remove peer');
}
